module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA3CAYAAABZ0InLAAAAn0lEQVRoge3aQQqAIBQAUQ3P4v2vo5epTctfUCQ5Mm8TBIKDGz+YW2t7mls+v6/2uX24kSkZSGcgnYF0BtIZSFf+3sADOfpZa71d5AlOJJwmeu+3i5Y/QQPpDKQzkM5AOgPplg8kXbYdlyKkE3RcihhIZyCdgXQG0hlIV9LFLX1CThORkp4/kXr7tGrIOqeJvzcwmoF0BtIZSGcg3fKBB8iEFAWAsHAGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/1+7.png
// module id = A4jN
// module chunks = 0